import { render, staticRenderFns } from "./noTakeEffect.vue?vue&type=template&id=29f207b8&scoped=true&lang=pug&"
import script from "./noTakeEffect.vue?vue&type=script&lang=js&"
export * from "./noTakeEffect.vue?vue&type=script&lang=js&"
import style0 from "./noTakeEffect.vue?vue&type=style&index=0&id=29f207b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f207b8",
  null
  
)

export default component.exports